import EmptyStateCard from './EmptyStateCard';

export default EmptyStateCard;
